import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { templatesModel } from '@/entities/templates';

import {
  getAvailableTemplateLanguages,
  resolveTemplateListLanguage,
} from '../lib';

import { useTemplateLanguageParam } from './useTemplateLanguageParam';

export const useTemplateLanguageFilter = () => {
  const { locale } = useIntl();
  const allSchemas = useAppSelector(
    templatesModel.selectors.selectEncounterSchemas,
  );
  const allTemplates = useAppSelector(
    templatesModel.selectors.selectAllDocumentTemplates,
  );

  const { language: languageParam, setLanguage } = useTemplateLanguageParam();

  const availableLanguages = useMemo(
    () =>
      getAvailableTemplateLanguages({
        schemas: allSchemas,
        templates: allTemplates,
      }),
    [allSchemas, allTemplates],
  );

  const language = resolveTemplateListLanguage({
    languageParam,
    availableLanguages,
    locale,
  });

  return { availableLanguages, language, setLanguage };
};
